<template>
  <div class="ajax-loader" v-html="vals.loader"></div>
</template>

<script>
export default {
  name: 'AjaxLoader',
}
</script>

<style scoped lang="scss">
.ajax-loader {
  position: fixed;
  top: var(--wp-adminbar-height);
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(#000, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  cursor: wait;
  z-index: 100;
}
</style>
